import React from 'react';
import styled from 'styled-components';

import { OFFLINE_EVENT_DROPDOWN_ANCHOR } from '@src/const/event';

import Dropdowns from './dropdowns';
import SaleCountdown from './saleCountdown';
import SoldOut from './soldOut';

const SelectionWrapper = styled.div`
	padding-bottom: 12px;
	border-bottom: 1px solid #F0F0F0;
	margin-top: 12px;

	@media ${props => props.theme.device.tablet} {
		padding-bottom: 16px;
		margin-top: 16px;
	}

	@media ${props => props.theme.device.smTablet} {
		padding-bottom: 16px;
		margin-top: 16px;
	}

	@media ${props => props.theme.device.mobile} {
		border-bottom: none;
		margin: 0;
	}
`;

interface ITicketSelection {
	className?: string;
	showCountdown: boolean;
	timeForCountdown: string;
	showSoldOut: boolean;
	enablePurchase: boolean;
	slotType: string;
	ticketType: string;
	ticketNumber: number;
	dropdownError: {
		slotType: boolean;
		ticketType: boolean;
		ticketNumber: boolean;
	};
	handleSelectSlot: (type: string) => void;
	handleSelectTicket: (type: string) => void;
	handleSelectTicketNumber: (type: number) => void;
}

const TicketSelection = ({
	className, showCountdown, timeForCountdown, showSoldOut, enablePurchase, slotType, ticketType, ticketNumber,
	dropdownError, handleSelectSlot, handleSelectTicket, handleSelectTicketNumber,
}: ITicketSelection): JSX.Element => (
	<SelectionWrapper id={OFFLINE_EVENT_DROPDOWN_ANCHOR} className={className}>
		{showCountdown && <SaleCountdown time={timeForCountdown} />}
		{showSoldOut && <SoldOut />}
		{enablePurchase && (
			<Dropdowns
				slotType={slotType}
				ticketType={ticketType}
				ticketNumber={ticketNumber}
				dropdownError={dropdownError}
				handleSelectSlot={handleSelectSlot}
				handleSelectTicket={handleSelectTicket}
				handleSelectTicketNumber={handleSelectTicketNumber}
			/>
		)}
	</SelectionWrapper>
);

export default TicketSelection;
